import React from "react";
import Text from "@src/lib/ui/Text";
import ClickableLinkText from "../../../lib/ui/ClickableLinkText";
import { useToggleDetailSidebar } from "@src/features/sidebars/hooks/useToggleDetailSidebar";
import { DetailSidebarType } from "@src/features/sidebars/detailSidebar";

type ClickableItem = {
  id: number;
  name: string;
};

type Props = {
  items: ClickableItem[];
  sidebarType: DetailSidebarType;
  tableId: string;
};

const CommaSeparatedLinks: React.FC<Props> = ({
  items,
  sidebarType,
  tableId,
}) => {
  const { toggleSidebar } = useToggleDetailSidebar();

  if (items.length === 0) {
    return <Text variant="compact-description">--</Text>;
  }

  return (
    <div className="flex items-center gap-1">
      {items.map((item, index) => (
        <div className="flex items-center gap-[0.5px] " key={item.id}>
          <ClickableLinkText
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleSidebar(
                e as React.MouseEvent<HTMLDivElement>,
                String(item.id),
                sidebarType,
                tableId,
              );
            }}
          >
            {item.name}
          </ClickableLinkText>
          {index < items.length - 1 && (
            <Text variant="compact-description">{", "}</Text>
          )}
        </div>
      ))}
    </div>
  );
};

export default CommaSeparatedLinks;
